import React, { Component } from "react";
import moment from "moment";
import Content from "../../content/Content";
import Store from "../../content/Store";
import PolicyDescription from "../shared/PolicyDescription";
import styles from "../../assets/css/modules/chooseyourplan/policy-panel.css";
import { BrandTypes, Layouts } from "../../constants/Constants";

export default class PolicyPanel extends Component {
  static lapsedStatus = "LAPSED";
  static currentStatus = "CURRENT";

  render() {
    const { policy = {}, isSelected, layout } = this.props;
    const isDisabledInHOLAxaHealth =
      policy.Brand === BrandTypes.AXA && layout === Layouts.HOL;

    let statusMessage = policy.IsLapsed
      ? PolicyPanel.lapsedStatus
      : PolicyPanel.currentStatus;
    if (isDisabledInHOLAxaHealth) {
      statusMessage = <Content name={Store.ChooseYourPlan.PolicyPanelStatus} />;
    }

    let policyPanelMessage = null;
    if (policy.HasPolicyLapsedForMoreThan3Years) {
      policyPanelMessage = (
        <div className="panel-details-text-3">
          <Content name={Store.PolicyLaspedGreaterThan3Years} />
        </div>
      );
    } else if (isDisabledInHOLAxaHealth) {
      policyPanelMessage = (
        <div className="panel-details-text-3">
          <Content name={Store.ChooseYourPlan.MovedToAxaHealthMessage} />
        </div>
      );
    }

    let panelStatusColor = "green";
    if (isDisabledInHOLAxaHealth) {
      panelStatusColor = "blue";
    } else if (policy.IsLapsed) {
      panelStatusColor = "gray";
    }

    return (
      <span
        className={
          isDisabledInHOLAxaHealth || policy.HasPolicyLapsedForMoreThan3Years
            ? ""
            : "panel-cursor"
        }
      >
        <div
          className={isSelected ? "panel panel-selected" : "panel panel-normal"}
        >
          <div className="row">
            <div className={`col-3 ${styles.iconWrapper}`}>
              <i
                className={`${styles.icon} icon-health-critical-illness display-1 policy-panel-image`}
              />
            </div>
            <div className="col-9 panel-details-text">
              <div className="panel-details-text-1">
                <PolicyDescription
                  productType={policy.ProductType}
                  isSME={policy.IsSME}
                  policyDescription={<Content name={Store.ProductType} />}
                />
              </div>
              <div className="membership">
                Membership Number: {policy.MembershipNumber}
              </div>
              <div className="panel-details-text-2">
                Joined:{" "}
                <span className="joinDate">
                  {moment(policy.PolicyStartDate).format("DD MMMM YYYY")}
                </span>
                {policy.IsLapsed ? (
                  <span className="lapseDate">
                    , Ended: {moment(policy.LapsedDate).format("DD MMMM YYYY")}
                  </span>
                ) : null}
              </div>
              <div className={`panel-status panel-status-${panelStatusColor}`}>
                <div
                  className={`panel-status-text panel-status-text-${panelStatusColor} status`}
                >
                  {statusMessage}
                </div>
              </div>
              {policyPanelMessage}
            </div>
          </div>
        </div>
      </span>
    );
  }
}
